import * as Yup from 'yup';

export const SignUpOptionsSchema = Yup.object().shape({
  accountCreatorRole: Yup.string().required('Please select your role'),
  customRole: Yup.string().when('accountCreatorRole', {
    is: 'RoleNotListed',
    then: (schema) => schema.required('Please enter your role'),
    otherwise: (schema) => schema.notRequired(),
  }),
});

export type SignUpOptionsDataType = Yup.InferType<typeof SignUpOptionsSchema>;

type InitialValues = {
  accountCreatorRole: string;
  customRole: string;
};

export const signUpOptionsInitialValues: InitialValues = {
  accountCreatorRole: '',
  customRole: '',
};


export interface OptionsSliderInterface {
  accountCreatorRole: string;
  customRole?: string;
}
